module.exports = __webpack_public_path__ + "img/compliance-dark.8be97c45.svg";